<template>
    <PageWrapper :logo="true">
        <transition name="slide-fade" mode="out-in">
            <router-view class="child"></router-view>
        </transition>
        <Divider size="2em" />
        <Legal />
    </PageWrapper>
</template>

<script>
import Legal from "@bistudio/bohemia-vue-components-old/src/components/footer/partials/Legal";

export default {
    name: "auth",
    components: { Legal },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
